<template>
    <section>
        <div class="page-wrap">
            <div class="container">
                <div class="box-content">
                    <h2>Not Found</h2>
                    <div class="font-lg">
                        <p>The page you requested could not be found.</p>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script type="text/jsx">
    export default {
        name: 'notfound'
    }
</script>

<style>
</style>



// WEBPACK FOOTER //
// NotFound.vue?09027590